import Layout from '@/components/layout/index.vue'
export default {
  path: 'statementofaccount',
  name: 'Statementofaccount',
  meta: {},
  component: Layout,
  redirect: { name: 'Supplier.Statementofaccount.InvoiceList' },
  children: [
    {
      path: 'invoiceList',
      name: 'Supplier.Statementofaccount.InvoiceList',
      meta: {},
      component: () => import(/* webpackChunkName: "statementofaccount" */ '@/views/supplier/statementofaccount/invoice/index.ts')
    },
    {
      path: 'add-one-ticket/:id',
      name: 'Supplier.Statementofaccount.AddOneTicket',
      meta: { dep: 'Supplier.Statementofaccount.InvoiceList', title: 'common.add' },
      component: () => import(/* webpackChunkName: "statementofaccount" */ '@/views/supplier/statementofaccount/add-one-ticket/index.vue')
    },
    {
      path: 'add-more-ticket/:id',
      name: 'Supplier.Statementofaccount.AddMoreTicket',
      meta: { dep: 'Supplier.Statementofaccount.InvoiceList', title: 'common.add' },
      component: () => import(/* webpackChunkName: "statementofaccount" */ '@/views/supplier/statementofaccount/add-more-ticket/index.vue')
    }
  ]
}
